import { render, staticRenderFns } from "./MultiPeriod.vue?vue&type=template&id=621272fe&scoped=true"
import script from "./MultiPeriod.vue?vue&type=script&lang=ts"
export * from "./MultiPeriod.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621272fe",
  null
  
)

export default component.exports